import { BYTES_IN_KILOBYTE, KILOBYTES_IN_MEGABYTE } from '../../constants/fileSize';
import { ValidationResult } from '../../types/fileValidation';
export const validateFile = (file: File): ValidationResult => {
  const maxSize = 10 * BYTES_IN_KILOBYTE * KILOBYTES_IN_MEGABYTE;
  if (file.size > maxSize) {
    return {
      isValid: false,
      error: 'File size should not exceed 10MB',
    };
  }
  const allowedExtensions = ['.xlsx', '.xls', '.csv'];
  const fileExtension = file.name.toLowerCase().slice(file.name.lastIndexOf('.'));
  if (!allowedExtensions.includes(fileExtension)) {
    return {
      isValid: false,
      error: 'Only Excel (.xlsx, .xls) and CSV files are allowed',
    };
  }
  return { isValid: true };
};
